module.exports = __webpack_public_path__ + "static/media/icon_star_fill.0c0673f0.svg";